
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.91045 0L2.51089 3.39956V22H19.4892V0H5.91045ZM6.26164 1.47181V3.75074H3.9827L6.26164 1.47181ZM18.2001 20.7109H3.79996V5.0398H7.5507V1.28906H18.2001V20.7109H18.2001Z"}}),_c('path',{attrs:{"d":"M5.08902 16.7426H10.3555V9.00818H5.08902V16.7426ZM6.37808 10.2972H9.06642V15.4535H6.37808V10.2972Z"}}),_c('path',{attrs:{"d":"M11.6445 10.2972H16.911V11.5863H11.6445V10.2972Z"}}),_c('path',{attrs:{"d":"M11.6445 12.8754H16.911V14.1644H11.6445V12.8754Z"}}),_c('path',{attrs:{"d":"M11.6445 15.4535H16.911V16.7426H11.6445V15.4535Z"}})])
          )
        }
      }
    